import makeApi from '../client/api'
import get from 'lodash/get'

export const createProposition = async (token, payload) => {
  const api = makeApi({ token })
  const data = { ...payload, source: 'web' }

  let existingPropositionId
  let response
  try {
    response = await api.create('/propositions', { data })
  } catch (err) {
    existingPropositionId = get(err, 'data.details.existing_proposition')
  }

  if (existingPropositionId) {
    try {
      response = await api.update('/propositions', { data, id: existingPropositionId })
    } catch (e) {
      throw e
    }
  }

  return response
}

export const deleteProposition = async (token, id) => {
  const api = makeApi({ token })
  const response = await api.deleteOne('/propositions', { id })

  return response
}

export const createContract = async (token, data) => {
  const api = makeApi({ token })
  const response = await api.create('/contracts', { data })

  return response
}

export const getUserPublicData = async ({ token, email, cpf = '', phone = '' }) => {
  const { api } = makeApi({ token })

  const searchResponse = await api.get('/users/get-public-data', {
    email: email,
    ...(!!cpf && { cpf }),
    ...(!!phone && { phone }),
  })

  if (!searchResponse.ok) {
    throw new Error(get(searchResponse, 'originalError.response.data.error'))
  }

  return searchResponse.data
}

export const createInsurance = async (token, insurance) => {
  const { api } = makeApi({ token })

  let insuranceResponse

  try {
    insuranceResponse = await api.post('/insurances', insurance)
  } catch (err) {
    // insuranceResponse = await api.patch('/insurances',)
  }

  return insuranceResponse.data
}

export const insuranceCheck = async (token, insuranceId) => {
  const api = makeApi({ token })

  const insuranceCheck = await api.getOne('/insurances', { id: insuranceId })

  return insuranceCheck.data
}
